import { CLASSES } from '../_consts';

export default function tabsInit() {

  const links = Array.prototype.slice.call(document.querySelectorAll('.js-tab-link'));
  const contentBlocks = Array.prototype.slice.call(document.querySelectorAll('.js-tab-content'));
  const { isActive } = CLASSES;

  if (links.length) {
    links.forEach((element) => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        for (let i = 0; i < links.length; i++) {
          links[i].classList.remove(isActive);
          contentBlocks[i].classList.remove(isActive);
        }
        const el = e.currentTarget;
        el.classList.add(isActive);
        const target = el.getAttribute('data-tab-target');
        const contentBlocksArr = Array.prototype.slice.call(document.querySelectorAll(`[data-tab-content="${target}"]`));

        contentBlocksArr.forEach((content) => {
          content.classList.add(isActive);
        });

        window.psInstances.forEach((ins) => {
          ins.update();
        });
      });
    });
  }
}
